export enum ClassAppointmentBehaviour {
  Anyone_Free = 0,
  Session_Pack = 1,
  Membership_Session_Pack = 2,
  Members_Only_Session = 3,
}

export enum AppointmentCommissionMode{
  NoCommission="No Commission",
  RevenueShare="Revenue Share",
  FlatFees="FlatFees",
}


export enum AppointmentBehaviour {
  Session_Pack = "Session Pack",
  Membership_Session_Pack = "Membership + Session Pack",
  Anyone_Free = "Anyone (Free)",
  Members_Only_Session = "Members Only Session",
}

export enum ThingsToCarry{
  Water_Bottle="Water Bottle",
  Id_card="Id card",
  Towel="Towel",
  Resistance_N="Resistance N",
}

export enum AppointmentDurations{
  "15 min"="15",
  "30 min"="30",
  "45 min"="45",
  "60 min"="60",
  "90 min"="90",
}








